interface Benefit {
  title: string;
  description: string;
}

interface BenefitsData {
  particuliers: Benefit[];
  entreprises: Benefit[];
}

export const benefitsData: BenefitsData = {
  particuliers: [
    {
      title: 'Des économies concrètes',
      description:
        "Modernisez vos équipements à moindre coût et réduisez vos factures d'énergie.",
    },
    {
      title: 'Un processus simple',
      description:
        "Nous nous occupons de tout, de l'estimation à l'installation.",
    },
    {
      title: "Un geste pour l'environnement",
      description:
        'Adoptez des solutions durables et contribuez à la transition énergétique.',
    },
  ],
  entreprises: [
    {
      title: 'Respectez la réglementation',
      description:
        'Assurez votre conformité avec les obligations du dispositif.',
    },
    {
      title: 'Maximisez votre retour sur investissement',
      description:
        "Bénéficiez d'un accompagnement clé en main pour optimiser vos projets.",
    },
    {
      title: 'Atteignez vos objectifs de durabilité',
      description:
        'Réduisez votre empreinte carbone tout en réduisant vos coûts.',
    },
    {
      title: 'Réduisez vos pertes financières',
      description:
        "Une non-conformité d'un dossier signifie une perte sèche pour votre société.",
    },
  ],
};
